import { Box, Text } from '@wix/design-system';
import React from 'react';
export const HeadingStructureRuleHeader = _ref => {
  let {
    headingDefinition,
    headingContent,
    status
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, {
    alignSelf: "center",
    cursor: "pointer",
    width: "216px"
  }, /*#__PURE__*/React.createElement(Box, {
    align: "center",
    backgroundColor: "D75",
    border: "1px solid #E2E3EA",
    borderRadius: "4px",
    height: "30px",
    width: "30px"
  }, /*#__PURE__*/React.createElement(Box, {
    marginTop: "7px"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    skin: !status ? 'error' : undefined,
    weight: "bold"
  }, headingDefinition ?? 'p'))), /*#__PURE__*/React.createElement(Box, {
    marginLeft: "SP2",
    verticalAlign: "middle",
    width: "170px"
  }, /*#__PURE__*/React.createElement(Text, {
    ellipsis: true,
    maxLines: 2,
    size: "tiny",
    weight: "normal",
    zIndex: 1
  }, headingContent)));
};
//# sourceMappingURL=heading-structure-rule-header.js.map